import { ErrorHandler, Injectable } from '@angular/core';
import { logImpression } from '@office-start/telemetry-service';
import { Area } from '@office-start/telemetry-types';

import { ApplicationError } from '../../error-handler/error-handler.service';
import { JsonElementParser } from '../utilities/json-element-parser.utility';
import { ApiConfigurationDataService } from './api-configuration-data.service';

@Injectable()
export class ApiConfigParserService {
    private readonly configMap: Map<string, string>;
    private readonly shouldSample: boolean;

    constructor(
        private readonly apiConfigurationDataService: ApiConfigurationDataService,
        private readonly globalErrorHandler: ErrorHandler
    ) {
        this.configMap = new Map(Object.entries(this.apiConfigurationDataService.shellAndConfigData));
        this.shouldSample = Math.random() <= 0.01; // 1% sampling rate
    }

    public parse<T>(
        configElementId: string,
        containsEncodedStrings = false
    ): T {
        try {
            if (this.shouldSample) {
                logImpression({
                    eventName: configElementId,
                    area: 'ApiConfigParserService' as Area
                });
            }

            if (this.configMap.has(configElementId)) {
                if (containsEncodedStrings) {
                    const decodedText = JsonElementParser.decodeJsonString(this.configMap.get(configElementId));
                    return JSON.parse(decodedText) as T;
                } else {
                    return JSON.parse(this.configMap.get(configElementId)) as T;
                }
            } else {
                return JsonElementParser.parseJsonElementWithId(configElementId) as T;
            }
        } catch (ex) {
            const wrappedError = new ApplicationError(`Failure to parse ${configElementId} from ShellConfig response`, ex);
            this.globalErrorHandler.handleError(wrappedError);
        }
    }
}
